import { Component, OnInit } from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import { Apollo } from 'apollo-angular';
import { ContratistaService } from 'src/app/services/contratista.service';
import { MatDialog } from "@angular/material/dialog";
import { ValidacionesService } from 'src/app/services/validaciones.service';

@Component({
  selector: 'app-nuevo-contratista',
  templateUrl: './nuevo-contratista.component.html',
  styleUrls: ['./nuevo-contratista.component.scss']
})
export class NuevoContratistaComponent implements OnInit {
  isLinear = false;
  datosContratista: any={};

  constructor(private formBuilder: FormBuilder, private apollo: Apollo, private contratistaService: ContratistaService, public dialog: MatDialog, private validacionService:ValidacionesService) {
    this.buildForm();
  }

  ngOnInit(): void {
  }

  private buildForm(){
    this.datosContratista = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      cif: ['',[Validators.required, this.validCif()]],
      nombreContacto: ['', [Validators.required]],
      mailContacto: ['', [Validators.required,Validators.email]],
    });
    /* this.documentosGestor = this.formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
 */
    /* this.datosGestor.valueChanges
    .subscribe(value => {
      console.log(value);
    }); */

    }
  
save(event:Event){
    event.preventDefault();
    const value = this.datosContratista.value;
    console.log(value);
  }

  addContratista(){
    console.log(this.datosContratista.value)
    this.apollo.mutate({
      mutation: this.contratistaService.addContratista(),
      variables: {
        "input": {
          "data": {
            "nombreComercial": this.datosContratista.value.nombre,
            "cif": this.datosContratista.value.cif,
            "contactoResponsable": {
              "nombre":this.datosContratista.value.nombreContacto,
              "mail": this.datosContratista.value.mailContacto,
            }
          }
        }
      }
    }).subscribe(({data}) => {
      console.log('OK', data)
      location.reload()
    }, (error) => {
      console.log('Error al lanzar la query', error);
    })
  }

  validCif(){
    return (control: AbstractControl):{[key: string]: boolean} | null=>{
    
    
   let cif:any = control.value
   
      if(this.validacionService.checkCif(cif) == false){
      
        return {'validCif':true}
      }
    return null;
    
  }
}

}

